import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductBaseInfoFragmentDoc } from './Product.generated';
import { ReflectionBaseFragmentDoc } from './Reflection.generated';
import { OrderLineVariantFragmentDoc } from './OrderLineVariant.generated';
export type OrderLineFragment = { id: string, pk: number, productName: string, isShippingRequired: boolean, quantity: number, hasFeedback: boolean, isCredit: boolean, isSubscription: boolean, unitPriceNet: any, originalPriceNet: any, discountName: string, unitCustomDiscount: any, discountAmount: { gross: number, currency: string }, supplyTotal: { gross: number, currency: string }, total: { gross: number, currency: string }, downloads: Array<{ id: string, pk: number, numAttempts: number, maxDownloads: number, fileName: string, downloadable: boolean, downloadLink: string, isOneTime: boolean, lastDownload: any | null, size: number }>, variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, thumbnail: { lg: string | null, sm: string | null }, properties: Array<{ pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } | null, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, thumbnail: { lg: string | null, sm: string | null } } | null, salesChannelProduct: { thumbnailUrl: string | null, id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string } | null, supplyParts: Array<{ id: string, pk: number, quantity: number, unitPriceNet: any, originalPriceNet: any, unitCustomDiscount: any, discountName: string, discountAmount: { gross: number, currency: string }, variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, properties: Array<{ pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } | null }> };

export const OrderLineFragmentDoc = gql`
    fragment OrderLineFragment on OrderLineType {
  id
  pk
  productName
  isShippingRequired
  quantity
  hasFeedback
  isCredit
  isSubscription
  unitPriceNet
  originalPriceNet
  discountName
  unitCustomDiscount
  discountAmount {
    gross
    currency
  }
  supplyTotal {
    gross
    currency
  }
  total {
    gross
    currency
  }
  downloads {
    id
    pk
    numAttempts
    maxDownloads
    fileName
    downloadable
    downloadLink
    isOneTime
    lastDownload
    size
  }
  variant {
    id
    thumbnail {
      lg(size: "600x0", method: THUMBNAIL_WEBP)
      sm(size: "300x0", method: THUMBNAIL_WEBP)
    }
  }
  product {
    ...ProductBaseInfoFragment
    weight
    manufacturer {
      id
      name
    }
    thumbnail {
      lg(size: "600x0", method: THUMBNAIL_WEBP)
      sm(size: "300x0", method: THUMBNAIL_WEBP)
    }
  }
  salesChannelProduct {
    ...ReflectionBaseFragment
    thumbnailUrl(size: "600x0", method: THUMBNAIL_WEBP)
  }
  supplyParts {
    id
    pk
    quantity
    unitPriceNet
    originalPriceNet
    unitCustomDiscount
    discountAmount {
      gross
      currency
    }
    discountName
    ...OrderLineVariantFragment
  }
  ...OrderLineVariantFragment
}
    ${ProductBaseInfoFragmentDoc}
${ReflectionBaseFragmentDoc}
${OrderLineVariantFragmentDoc}`;